import { render, staticRenderFns } from "./Feelings.vue?vue&type=template&id=70d07219&scoped=true"
import script from "./Feelings.vue?vue&type=script&lang=js"
export * from "./Feelings.vue?vue&type=script&lang=js"
import style0 from "./Feelings.vue?vue&type=style&index=0&id=70d07219&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d07219",
  null
  
)

export default component.exports